export default __webpack_public_path__ + "static/media/illustration-work-3-w@2x.bc2710ca.webp";